import { Injectable } from '@angular/core';
import { ApiObjectData } from '../models/api-object-data';
import { BaseService } from './base.service';
import { Observable } from 'rxjs';
import { TeacherBankInfo } from './../models/teacherBankInfo';


@Injectable({
    providedIn: 'root'
})

export class TeacherBankInfoService {
    controller = 'TeacherBankInfo';

    constructor(private base: BaseService) { } 

    registerTeacherBankInfo(obj: TeacherBankInfo) {
        return this.base.save(this.controller + '/RegisterTeacherBankInfo', obj);
    }

    getTeacherBankInfoById(teacherId: number): Observable<ApiObjectData> {
        return this.base.gets(this.controller + '/GetTeacherBankInfoById/' + teacherId)
    }

    deleteInfo(id: any) {
        return this.base.delete(this.controller + '/DeleteInfo/', id);
    }
}